var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('strong',{staticClass:"gl-font-weight-bold"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }